import React, { useContext } from "react";
import Card from "../../../Card";
import Table from "../../../Table";
import MainContext from "../../../../Context/MainContext/MainContext";
import User from "../../../../Utility/Crud/User";

export default function CardAdminRoleUsers(props) {
  const context = useContext(MainContext);

  const userprofileRoles = context.userprofileRolesIndexed
    ? Object.values(context.userprofileRolesIndexed)
    : [];
  const teamUsers = context.teamUsersIndexed
    ? Object.values(context.teamUsersIndexed)
    : [];

  const usersForRole = userprofileRoles
    .filter(
      (userprofileRole) =>
        userprofileRole.roleId === props.roleId &&
        userprofileRole.deleted !== true,
    )
    .map(
      (userprofileRole) => context.usersIndexed[userprofileRole.userProfileId],
    )
    .filter((user) => !!user && user.active === true);

  const usersForRoleById = {};
  usersForRole.forEach((user) => {
    usersForRoleById[user.id] = user;
  });

  const rows = Object.values(usersForRoleById).map((user) => {
    const memberTeams = teamUsers
      .filter(
        (teamUser) => teamUser.userId === user.id && teamUser.deleted !== true,
      )
      .map((teamUser) => context.teamsIndexed[teamUser.teamId])
      .filter((team) => !!team);
    const managedTeams = context.teamsIndexed
      ? Object.values(context.teamsIndexed).filter(
          (team) => team?.managerId === user.id,
        )
      : [];

    const teamNamesByName = {};
    memberTeams.concat(managedTeams).forEach((team) => {
      teamNamesByName[team.name] = true;
    });

    const userTeamNames = Object.keys(teamNamesByName).sort((a, b) =>
      a.localeCompare(b),
    );

    return {
      id: user.id,
      name: User.getDisplayName(user),
      teams: userTeamNames.join(", "),
    };
  });

  const sortedRows = rows.sort((a, b) => a.name.localeCompare(b.name));

  const renderContent = () => (
    <Table
      search={true}
      columns={[
        { key: "id", name: "ID", type: "number" },
        { key: "name", name: "Name", type: "string", width: "35%" },
        { key: "teams", name: "Teams", type: "string" },
      ]}
      sort={[
        {
          key: "name",
          direction: "ascending",
        },
      ]}
      rows={sortedRows}
    />
  );

  return <Card renderContent={renderContent} getTitle={() => "Users"} />;
}
